import React, { useState } from 'react';
import 'twin.macro';
import { v4 as uuid } from 'uuid';
import Button from '@teetsh/app/src/components/Buttons/Button';
import useCreateElevesView from '@teetsh/app/src/queries/eleves/views/useCreateElevesView';
import { elevesUrls } from '@teetsh/app/src/containers/Eleves/urls';
import { useSchoolGoTo } from '@teetsh/app/src/containers/App/useSchoolGoTo';
import InputGroup from '@teetsh/app/src/components/Form/InputGroup';
import { useTranslation } from 'react-i18next';

export function NewViewContent() {
  const { t } = useTranslation(['eleve', 'common']);
  const [viewName, setViewName] = useState(t('eleve:defaultListName'));
  const createView = useCreateElevesView();
  const goTo = useSchoolGoTo();
  return (
    <div>
      <p tw="mb-4 text-sm text-muted ">{t('eleve:newViewHelper')}</p>
      <InputGroup
        label={t('eleve:listName')}
        id="list-name"
        value={viewName}
        autoFocus
        onChange={v => setViewName(v)}
      />
      <div tw="text-right">
        <Button
          aria-label="Valider le nom de la vue"
          onClick={() => {
            const viewId = uuid();
            return createView({
              viewName,
              viewId,
            }).then(async () => {
              setTimeout(async () => {
                await goTo(elevesUrls.viewDetails(viewId));
              }, 20);
            });
          }}
        >
          {t('common:buttons.add')}
        </Button>
      </div>
    </div>
  );
}
